import { useAuth0 } from '@auth0/auth0-react'
import { useMemo } from 'react'
import { useDispatch } from 'react-redux'

import { clearAuth } from '../../../store/slices/authSlice'
import auth0Config from '../auth0/config/auth0'
import FamilyPortalAPIClient from '../FamilyPortalAPIClient'

const IDENTITY_VERIFIED_KEY = 'familyPortal.identityVerified'

export function useFamilyPortalApiClient() {
  const { getAccessTokenSilently, logout } = useAuth0()
  const dispatch = useDispatch()

  return useMemo(() => {
    return FamilyPortalAPIClient.getInstance(
      async () =>
        getAccessTokenSilently({
          authorizationParams: {
            audience: auth0Config.authorizationParams?.audience,
          },
        }),
      () => {
        // A 401 means the backend rejected our token. Tear the session down
        // (clear local state + end the Auth0 session) and land the user on the
        // login screen. Auth0 still holds a client-side session on a 401, so a
        // full logout is required — otherwise AuthGuard would bounce the user
        // straight back into the app.
        sessionStorage.removeItem(IDENTITY_VERIFIED_KEY)
        dispatch(clearAuth())
        void logout({ logoutParams: { returnTo: window.location.origin } })
      }
    )
  }, [getAccessTokenSilently, logout, dispatch])
}
